import {Select} from '@wandb/weave/components/Form/Select';
import {TextField} from '@wandb/weave/components/Form/TextField';
import React from 'react';

import {ErrorText, SeparatedChunk} from '../../shared';
import {comparisonOperatorOptions} from '../constants';
import {type ComparisonOperator, type ComparisonOperatorOption} from '../types';

type FloatMetricConfigProps = {
  threshold: string;
  operator: ComparisonOperator;
  onThresholdChange: (value: string) => void;
  onOperatorChange: (operator: ComparisonOperator) => void;
  hasError: boolean;
};

export const FloatMetricConfig = ({
  threshold,
  operator,
  onThresholdChange,
  onOperatorChange,
  hasError,
}: FloatMetricConfigProps) => {
  const currentOperatorOption =
    comparisonOperatorOptions.find(option => option.value === operator) ?? null;

  return (
    <SeparatedChunk>
      <div className="font-semibold">Metric threshold</div>
      <div className="mt-4 flex flex-row gap-8">
        <div className="w-full">
          <Select<ComparisonOperatorOption>
            value={currentOperatorOption}
            onChange={e => onOperatorChange(e?.value || 'GREATER_THAN')}
            options={comparisonOperatorOptions}
          />
        </div>
        <div className="w-full">
          <TextField
            ariaLabel="Threshold"
            value={threshold}
            onChange={onThresholdChange}
            placeholder="Ex. 0.8"
          />
        </div>
      </div>
      {hasError && <ErrorText>Threshold must be a valid number</ErrorText>}
    </SeparatedChunk>
  );
};
